import { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useTranslateGrade } from 'utils/customHooks/useTranslateGrade'
import { AppDispatch, RootState } from 'redux/store'
import { useDispatch, useSelector } from 'react-redux'
import React from 'react'
import { ArrowCircleDownOutlined, ArrowCircleRightOutlined } from '@mui/icons-material'
import { FaEye } from 'react-icons/fa'
import { CheckCircle, ForwardToInbox, MoreVert, Send } from '@mui/icons-material'
import { actionIcon, PRIMARY_GREEN } from 'utils/customizedTheme'
import { openContent } from 'utils/helpers'
import { usePOST_gradebookReportSendParentsMutation, usePOST_gradebookReportSendStudentMutation, usePOST_gradebookReportViewMutation } from 'redux/api/gradebookApi'
import { Button } from '@mui/material'
import { StudentAvatar } from '../student/StudentAvatar'

interface IProps {
  groupCourse: any
  courses: any[]
  students: any[]
}

const GroupCourseGradebookSummary: FC<IProps> = ({ groupCourse, courses, students }) => {
  const reduxKey = 'groupCourseGradebook'
  const { t } = useTranslation()
  const [translateGrade] = useTranslateGrade()
  const [openRow, setOpenRow] = useState(null)

  const academic_year = useSelector((state: RootState) => state[reduxKey].tableFilters.academic_year)
  const grade_level = useSelector((state: RootState) => state[reduxKey].tableFilters.grade_level)
  const selectedGradeLevel = groupCourse?.course?.grade_level || grade_level

  return (
    <>
      <div className='gradebook-grid-wrapper'>
        <table className='gradebook-grid gradebook-grid-summary' style={{ minWidth: `${ 620+courses.length*150 }px` }}>
          <tbody>
            <tr style={{ textAlign: 'center', fontWeight: '600', fontSize: '14px' }}>
              <td style={{ width: '200px'}}>
                {t('common.students')}
              </td>   
              <td style={{ width: '100px'}}>
                {t('common.group')}
              </td>  
              {courses.map(c => <td key={c.id} className='gradebook-grid-dark-blue'
                    style={{ width: '200px' }}
                 >
                  {c.title}
              </td>)}
              <td style={{ width: '120px'}} className='gradebook-grid-dark-blue'>
                {t('common.final-report')}
              </td>
            </tr>
            {students.map( (s, idx) => <React.Fragment key={`${s.id}`}>
              <tr key={s.id} className={`gradebook-main-row ${idx%2==0 ? 'odd' : 'even'}`}>
                <td style={{ paddingTop: '8px', paddingBottom: '8px' }}>
                  <div 
                    onClick={() => {
                      if(openRow == s.id)
                        setOpenRow(null)
                      else
                        setOpenRow(s.id)
                    }}
                     style={{ display: 'flex', gap: '5px', alignItems: 'center', cursor: 'pointer' }}>
                             {openRow == s.id 
                               ? <ArrowCircleDownOutlined sx={{ color: '#63b9ff' }} /> 
                               : <ArrowCircleRightOutlined sx={{ color: '#63b9ff' }} /> }
                             <span>
                                <StudentAvatar avatar={s.avatar} name={s.display_name} />
                             </span>
                           </div>
                         </td>  
                         <td style={{ textAlign: 'center' }}>
                             {s.group}
                         </td>  
                         {
                               courses.map(c => <td key={c.id} style={{ width: '150px', textAlign: 'center' }}>
                                      {s.final_grades?.find(g => g.course_id == c.id) 
                                      ? translateGrade(s.final_grades?.find(g => g.course_id == c.id).final_grade_percentage) 
                                      : ''}
                                 </td>
                               ) 
                         }
                         <td style={{ textAlign: 'center' }} className='gradebook-grid-dark-blue'>      
                           <Actions student_id={s.id} academic_year={academic_year} grade_level={selectedGradeLevel}/>                        
                         </td>
                       </tr> 
 
                       {openRow == s.id && s.academic_periods.map( (t,idx) => {
                 
                         return <tr key={t.id} className={`gradebook-grid-subrow ${idx%2==0 ? 'odd' : 'even'}`}>
                           <td colSpan={2} style={{paddingLeft: '35px'}}>
                             {t.title}
                           </td>
                           {
                               courses.map(c => 
                                   <td key={c.id} style={{textAlign: 'center'}}>
                                       {s.academic_periods?.find(g => g.course_id == c.id) 
                                         ? translateGrade(s.academic_periods?.find(g => g.course_id == c.id).grade_percentage) 
                                         : ''}
                                   </td>
                               ) 
                           }
                           <td></td>
                       </tr>})}
                     </React.Fragment>
                   )}
                 </tbody>
               </table>
           </div>
    </>
  )
}
export default GroupCourseGradebookSummary


interface IPropsActions {
  student_id: string
  academic_year: string,
  grade_level: string
}

const Actions: FC<IPropsActions> = ({ student_id, academic_year, grade_level }) => {
  const { t } = useTranslation()
  const [menuOpen, setMenuOpen] = useState(false)
  
  const [
    reportView, {isSuccess: isReportViewSuccess, data: reportViewData}
  ] = usePOST_gradebookReportViewMutation()

  const [
    sendStudent, {isSuccess: isSendStudentSuccess}
  ] = usePOST_gradebookReportSendStudentMutation()

  const [
      sendParents, {isSuccess: isSendParentsSuccess}
  ] = usePOST_gradebookReportSendParentsMutation()


  useEffect(() => {
    if(isReportViewSuccess && reportViewData){
      openContent(reportViewData.report)
    }
  }, [isReportViewSuccess, reportViewData])

  return (
        <div style={{ position: 'relative', display: 'inline-block' }}
           onMouseEnter={() => setMenuOpen(true)}
           onMouseLeave={() => setMenuOpen(false)}
        >
          <Button
            variant='outlined'
            color='black'
            disableElevation
            sx={{ ...actionIcon  }}
          >
            <MoreVert />
          </Button>

          <div style={{ 
              display: menuOpen ? 'flex' : 'none', 
              flexDirection: 'column', 
              gap: '5px',
              position: 'absolute',
              zIndex: 1,
              top: '0px',
              right: '0px',
              background: '#fff',
              boxShadow: 'rgba(0, 0, 0, 0.25) 0px 14px 28px, rgba(0, 0, 0, 0.22) 0px 10px 10px',
              padding: '5px',
              borderRadius: '5px',
              whiteSpace: 'nowrap'
            }}>
            <div onClick={() => {reportView({academic_year, grade_level, student_id})}} style={{ display: 'flex', gap: '5px', cursor: 'pointer', alignItems: 'center' }}>
              <FaEye fontSize={'22px'}/> {t('common.view-report')}
            </div>
            <div onClick={() => sendStudent({academic_year, grade_level, student_id})} style={{ display: 'flex', gap: '5px', cursor: 'pointer', alignItems: 'center' }}>
              {isSendStudentSuccess ? <CheckCircle sx={{color: PRIMARY_GREEN}} /> : <Send />}
              {t('common.send-to-student')}
            </div>
            <div onClick={() => sendParents({academic_year, grade_level, student_id})} style={{ display: 'flex', gap: '5px', cursor: 'pointer', alignItems: 'center' }}>
              {isSendParentsSuccess ? <CheckCircle sx={{color: PRIMARY_GREEN}} /> : <ForwardToInbox /> }
              {t('common.send-to-parents')}
            </div>
          </div>
        </div>
    )
}
